// extracted by mini-css-extract-plugin
export default {"container":"WSSelectDisplay-module_container-Sh9vo","option":"WSSelectDisplay-module_option-Yt9ef","selected":"WSSelectDisplay-module_selected-CZ4bA"};